export class InactiveIngredientContentModel {
    public inactiveIngredientId: number;
    public langId: number;
    public name: string;
}